import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router";
import Svg from "../components/figs/Svg";
import { useForm } from "react-hook-form";
import api from "../routes/api";
import { useAlertModal } from "../hooks/useAlertModal";
import Loading from "../components/Loading";

export default function CreatePassword() {
  const { msg } = useSelector((s) => s.language);
  const [isLoading, setIsLoading] = useState(false);
  const { alert, AlertModal } = useAlertModal();
  const loc = useLocation();
  const searchParams = new URLSearchParams(loc.search);
  const token = searchParams.get("token");
  const [section, setSection] = useState("preCreatePassword");
  const [message, setMessage] = useState("");

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const newPassword = watch("new_password");
  const confirmPassword = watch("confirm_password");
  const passwordsMatch = newPassword === confirmPassword;

  const onSubmit = async (data) => {
    // Handle the form submission logic here
    setIsLoading(true);
    if (!token) {
      alert(msg.alert, msg.token_not_found);
      setIsLoading(false);
      return;
    }
    const password = data.new_password;
    await fetch(api.auth.createPassword, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({ password }),
    })
      .then((response) => {
        if (response.status === "error") {
          throw new Error("Failed to create password");
        }
        return response.json();
      })
      .then((result) => {
        if (result.status === "error") {
          alert(msg.alert, result.msg || msg.try_again);
          setIsLoading(false);
          return;
        }
        setSection("postCreatePassword");
        setMessage(result.msg);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <>
      <div className="page_auth">
        <div className="_main_bg"></div>
        <div className="logo_app">
          <Svg iconName="logo" />
        </div>
        {section === "preCreatePassword" && (
          <>
            <div className="signin">
              <h1 className="mini">{msg.create_password}</h1>
              <p>{msg.welcome_to_inverz_agent_marine}</p>
              <div className="form">
                <input
                  type="password"
                  placeholder={msg.new_password}
                  {...register("new_password")}
                />
                <input
                  type="password"
                  placeholder={msg.confirm_password}
                  {...register("confirm_password")}
                />
                <button
                  disabled={!passwordsMatch}
                  className={passwordsMatch && newPassword ? "" : "disabled"}
                  onClick={handleSubmit(onSubmit)}
                  type="submit"
                >
                  {msg.submit}
                </button>
              </div>
            </div>
            <div className="section_below_of_form">
              <p>
                <Link to="/?resetPassword=true">{msg.reset_password}</Link>
              </p>
            </div>
          </>
        )}
        {section === "postCreatePassword" && (
          <>
            <div className="p-8 rounded-2xl shadow-lg bg-[var(--bright)] min-w-[20rem] text-center flex flex-col gap-y-4">
              <p className="w-full text-[var(--primary)] text-[1.2rem]">
                {message}
              </p>
              <Link to="/" className="_fill_button_2 w-full">
                {msg.sign_in}
              </Link>
            </div>
          </>
        )}
        {isLoading && <Loading />}
      </div>
      {AlertModal}
    </>
  );
}
